// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navContainer":"_1aQxPy","button":"_3oZE12","closeButton":"_3k8Ds6","nwLink":"vcgw_1","nwLogo":"tsz2LT","backLabel":"zmMaGu","backButton":"_2QL12X"};